<template>
  <div class="page_salary page_offlineSalary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" v-if="activeName=='0'">
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申报月" size="small" label-width="70px">
              <el-date-picker v-model="listQuery.IncomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="个税申报类型" size="small" label-width="100px">
              <el-select v-model="listQuery.IncomeTaxType" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option value="正常工资薪金"></el-option>
                <el-option value="劳务报酬"></el-option>
                <el-option value="全年一次性奖金（一次扣税）"></el-option>
                <el-option value="全年多次性奖金（多次发放）"></el-option>
                <el-option value="解除劳动合同一次性补偿"></el-option>
                <!-- <el-option value="个税差额补发"></el-option>
                <el-option value="不算税"></el-option> -->
              </el-select>
            </el-form-item>

          </el-form>
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" v-if="activeName=='1'">
            <el-form-item label="法务主体" size="small" label-width="90px">
              <el-select v-model="listQuery.CompanyName" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="税款所属期" size="small" label-width="90px">
              <el-date-picker v-model="listQuery.IncomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="89px">
          <div>
            <el-form-item label="商务合同主体" size="small" label-width="99px">
              <el-input v-model="listQuery.name" size="small" style="width:180px" clearable></el-input>
            </el-form-item>
            <el-form-item label="客户名称" size="small">
              <el-input v-model="listQuery.CustomerName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="发放途径" size="small">
              <el-select v-model="listQuery.name" placeholder="" style="width:180px" clearable filterable>
                <el-option value="银行"></el-option>
                <el-option value="灵活用工"></el-option>
                <!-- <el-option value="安心云"></el-option> -->
                <el-option value="现金"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- <div>
            <el-form-item label="服务部门" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/calcSalary' }">算薪</el-breadcrumb-item>
          <el-breadcrumb-item>线下发薪数据维护</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="导入线下发薪数据" name="0"></el-tab-pane>
          <el-tab-pane label="登记线下个税申报" name="1" v-if="checkPermission(['salary_offlineTaxSigning'],permissionLists)"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="importForm" v-if="activeName=='0'">导入薪资表</el-button>
          <el-button type="warning" size="small" @click="exportDtl" v-if="activeName=='0' && isFin" :loading="isExpLoading">导出明细</el-button>
          <el-button type="success" size="small" @click="signing" v-if="activeName=='1'">登记已申报</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" key="table1" v-if="activeName=='0'" :row-class-name="tableRowClassName">
          <el-table-column prop="ProjectName" label="发薪项目" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncomeTaxType" label="个税申报类型" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AttrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncomeTaxMonth" label="申报月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="上传时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}
            </template>
          </el-table-column>
          <el-table-column label="税务校验结果" min-width="260" align="center">
            <template slot-scope={row}>
              共 <span class="blueName" @click="exportHandel(row,'','所有人员')">{{row.TotalPayrolls ? row.TotalPayrolls : 0}}</span> | <span class="blueName" @click="exportHandel(row,'4','校验成功')">{{row.ckeckOkCount ? row.ckeckOkCount : 0}}</span>人校验成功
              | <span class="blueName" @click="exportHandel(row,'3','校验失败')">{{row.ckeckErrorCount ? row.ckeckErrorCount : 0}}</span>人校验失败
            </template>
          </el-table-column>
          <el-table-column label="算税结果" min-width="270" align="center">
            <template slot-scope={row}>
              <span class="blueName" @click="exportHandel2(row,'算税成功','算税成功')">{{row.TaxSuccessCount ? row.TaxSuccessCount : 0}}</span> 人算税成功
              | <span class="blueName" @click="exportHandel2(row,'算税失败','算税失败')">{{row.TaxFailCount ? row.TaxFailCount : 0}}</span>算税失败
              | <span class="blueName" @click="exportHandel2(row,'未算税','未算税')">{{row.TaxNotCount ? row.TaxNotCount : 0}}</span>人未算税
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="140px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="toDetail(row)">查看</el-button>
                <el-button type="text" @click="getTax(row)">算税</el-button>
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>

              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="taxSignData" border class="doc_table" v-loading="loading" style="width:100%" key="taxSignData" v-if="activeName=='1'">
          <el-table-column prop="CompanyName" label="法务主体" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncomeTaxMonth" label="税款所属期" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="登记时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="ProjectName" label="操作" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-popconfirm title="请确定是否作废？" @confirm="delSign(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="导入薪资表" :visible.sync="showImport" width="600px">
      <el-form :model="formData" ref="formImport" :rules="rules" label-width="110px">
        <el-form-item label="发薪项目" prop="ProjectId">
          <el-select v-model="Project" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="个税申报类型" prop="IncomeTaxType">
          <el-select v-model="formData.IncomeTaxType" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeIncomeTaxType">
            <el-option value="正常工资薪金"></el-option>
            <el-option value="劳务报酬"></el-option>
            <el-option value="全年一次性奖金（一次扣税）"></el-option>
            <el-option value="全年多次性奖金（多次发放）"></el-option>
            <el-option value="解除劳动合同一次性补偿"></el-option>
            <el-option value="个税差额补发"></el-option>
            <el-option value="不算税"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属月" prop="AttrMonth">
          <el-date-picker v-model="formData.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="申报月" prop="IncomeTaxMonth">
          <el-date-picker v-model="formData.IncomeTaxMonth" :picker-options="pickerOptions" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="导入模板">
          <el-button type="text" @click="downTemp">下载模板</el-button>
        </el-form-item>
        <el-form-item label="导入薪资表" prop="Url">
          <div style="width:300px">
            <el-upload class="upload-demo" action="" :on-remove="handleRemove1" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed1" :on-change="handleUploadPSR" accept=".xlsx,.xls" :file-list="fileListPSR">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="beforeImport" :loading="isBtnLoading">确 认</el-button>
      </span>

      <el-dialog title="批次确认" :visible.sync="showBatch" width="500px" append-to-body>
        <div>{{ formData.ProjectName }} 项目该月已导入薪资表，请确认是新增还是覆盖之前记录？</div>
        <div class="salaryPayingCompany_radio">
          <el-radio-group v-model="isMonthBatchMax">
            <el-radio label="0">新增</el-radio>
            <el-radio label="1">覆盖勾选的记录</el-radio>
          </el-radio-group>
        </div>

        <el-table :data="batchData" class="doc_table" style="width:100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="CreateTime" label="生成时间" width="250" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.CreateTime.replace('T', ' ') + '导入' }}</template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showBatch = false">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="getBatch()">确 认</el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <el-dialog title="登记线下个税申报" :visible.sync="showSigning" width="600px">
      <el-form label-width="110px">
        <el-form-item label="法务主体">
          <div class="flex">
            <el-select v-model="CompanyName" placeholder="" size="small" style="width: 300px;" clearable filterable multiple :disabled="checked">
              <el-option v-for="(item, index) in legList2" :key="index" :value="item.CompName"></el-option>
            </el-select>
            <el-checkbox v-model="checked" @change="changeCheck" style="margin-left:15px">法务主体全选</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="税款所属期" prop="reportingMonth">
          <el-date-picker v-model="IncomeTaxMonth" type="month" @change="getInternalCompNameList" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSigning = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSigning" :loading="isBtnLoading">确 认</el-button>
      </span>

      <el-dialog title="批次确认" :visible.sync="showBatch" width="500px" append-to-body>
        <div>{{ formData.ProjectName }} 项目该月已导入薪资表，请确认是新增还是覆盖之前记录？</div>
        <div class="salaryPayingCompany_radio">
          <el-radio-group v-model="isMonthBatchMax">
            <el-radio label="0">新增</el-radio>
            <el-radio label="1">覆盖勾选的记录</el-radio>
          </el-radio-group>
        </div>

        <el-table :data="batchData" class="doc_table" style="width:100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="CreateTime" label="生成时间" width="250" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.CreateTime.replace('T', ' ') + '导入' }}</template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showBatch = false">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="getBatch()">确 认</el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <el-dialog title="发薪公司错误，请修改后重新导入" :visible.sync="showLegError" width="600px">
      <!-- <div class="taxCheckTitle"></div> -->
      <el-table :data="LegalSubjectCheckList" style="width: 100%">
        <el-table-column prop="rowNum" label="行号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="Val" label="错误" min-width="300" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showLegError = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="数据异常提醒" :visible.sync="showAbnormal" :show-close="false" width="600px">

      <div v-if="ret1List.length > 0">
        <div class="abnormalTitle"><i class="el-icon-warning"></i> 异常提醒：</div>
        <div class="abnItem flex aic">
          <!-- 共导入 100 条数据， -->
          有 <span class="errNum">{{ ret1List.length }}</span> 人身份信息与花名册/商保参保信息比对不一致
          <el-popover placement="top" width="920" trigger="click">
            <el-table :data="ret1List">
              <el-table-column width="120" property="projectName" align="center" label="项目名称" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="120" property="EmpName" align="center" label="员工姓名"></el-table-column>
              <el-table-column width="160" property="StrIdCard" align="center" label="身份证号码"></el-table-column>
              <el-table-column width="120" property="PhoneNum" align="center" label="手机号"></el-table-column>
              <el-table-column width="120" property="StrWorkState" align="center" label="在/离职状态" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="170" property="CheckName" align="center" label="身份证信息与花名册对比" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="180" property="InsuranceNameCheck" align="center" label="身份信息与商保保信息比对" :show-overflow-tooltip="true">
                <template slot-scope={row}>
                  {{ row.InsuranceNameCheck ? row.InsuranceNameCheck : '无商保信息' }}
                </template>
              </el-table-column>
              <el-table-column width="170" property="CheckBankCard" align="center" label="姓名/银行卡与花名册比对" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="150" property="CheckPhoneNum" align="center" label="手机号与花名册比对" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="170" property="CheckEmploymentDay" align="center" label="入职日期与花名册比对" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
          </el-popover>
          <!-- <el-button type="text" size="small">下载</el-button> -->
        </div>
      </div>


      <div>
        <div class="abnItem flex aic">
          <!-- 共导入 100 条数据， -->
          有 <span class="errNum">{{ ret2List.length }}</span> 人无签约信息
          <el-popover placement="top" width="620" trigger="click">
            <el-table :data="ret2List">
              <el-table-column width="120" property="projectName" align="center" label="项目名称" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="120" property="EmpName" align="center" label="员工姓名"></el-table-column>
              <el-table-column width="160" property="StrIdCard" align="center" label="身份证号码"></el-table-column>
              <el-table-column width="120" property="PhoneNum" align="center" label="手机号"></el-table-column>
              <el-table-column width="90" property="SignatureStatus" align="center" label="是否签约"></el-table-column>
            </el-table>
            <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
          </el-popover>
          <!-- <el-button type="text" size="small">下载</el-button> -->
        </div>
        <div class="abnItem flex aic" v-if="IssuedThisMonthList.length > 0">
          <!-- 共导入 100 条数据， -->
          有 <span class="errNum">{{ IssuedThisMonthList.length }}</span>条数据本月同一个人有相同金额发薪数据
          <el-popover placement="top" width="800" trigger="click">
            <el-table :data="IssuedThisMonthList">
              <el-table-column width="120" property="ProjectName" align="center" label="项目名称"></el-table-column>
              <el-table-column width="120" property="EmployeeName" align="center" label="员工姓名"></el-table-column>
              <el-table-column width="160" property="CardId" align="center" label="身份证号码"></el-table-column>
              <el-table-column width="120" property="name" align="center" label="手机号"></el-table-column>
              <el-table-column width="90" property="IssuedThisMonth" align="center" label="实发金额" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="150" property="UpdataTime" align="center" label="发放时间" :show-overflow-tooltip="true">
                <template slot-scope={row}>
                  {{ row.UpdataTime ? row.UpdataTime.replace('T', ' ') : '' }}
                </template>
              </el-table-column>
              <el-table-column width="90" property="nPayrollChannelame" align="center" label="发放渠道" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="90" property="name" align="center" label="发薪主体" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
          </el-popover>
          <!-- <el-button type="text" size="small">下载</el-button> -->
        </div>
      </div>

      <div class="abnItem flex aic" v-if="BankAccountCheckList.length > 0">
        <!-- 共导入 100 条数据， -->
        有 <span class="errNum">{{ BankAccountCheckList.length }}</span>条数据银行卡号异常
        <el-popover placement="top" width="500" trigger="click">
          <el-table :data="BankAccountCheckList">
            <el-table-column width="120" property="EmployeeName" align="center" label="员工姓名"></el-table-column>
            <el-table-column width="100" property="rowNum" align="center" label="行号"></el-table-column>
            <el-table-column width="280" property="Val" align="center" label="异常提示"></el-table-column>
          </el-table>
          <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
        </el-popover>
        <!-- <el-button type="text" size="small">下载</el-button> -->
      </div>

      <div class="abnItem flex aic" v-if="CardIdCheckList.length > 0">
        <div class="errNumTips">有<span class="errNum">{{ CardIdCheckList.length }}</span>人有重复发薪数据，请仔细核对。</div>
        <el-popover placement="top" width="500" trigger="click">
          <el-table :data="CardIdCheckList">
            <el-table-column width="120" property="EmployeeName" align="center" label="员工姓名"></el-table-column>
            <el-table-column width="100" property="rowNum" align="center" label="行号"></el-table-column>
            <el-table-column width="280" property="Val" align="center" label="异常提示"></el-table-column>
          </el-table>
          <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
        </el-popover>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showAbnormal = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="continueSubmit">继 续</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showAllSign" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isSigning">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">
          人员校验进行中，预计耗时1~3分钟，请耐心等待......
        </div>
        <!-- <div class="footer">
          <el-button type="danger" size="small" @click="StopCheck" :loading="isloading">终止校验</el-button>
        </div> -->
      </div>
      <div v-if="!isSigning">
        人员校验结束，其中
        <span class="num1 success"> {{checkSuccess}} </span>
        人校验成功，<span class="num1 red"> {{checkFail}} </span>人校验失败
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isSigning">
        <!-- <el-button size="small" @click="showAllSign = false">关闭</el-button> -->
        <el-button size="small" type="primary" v-preventReClick :loading="taxLoading" @click="continueGetTax">继续算税</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showAllTax" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isTaxing">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">算税进行中，预计耗时1~5分钟，请耐心等待.....</div>
        <div class="footer">
          <!-- <el-button type="danger" size="small" @click="StopTax" :loading="isloading">终止算税</el-button> -->
        </div>
      </div>
      <div v-if="!isTaxing">
        算税结束，其中
        <span class="num1 success"> {{taxSuccess}} </span>
        人算税成功，<span class="num1 red"> {{taxFail}} </span>
        人失败
        <span v-if="taxNo>0">，<span class="num1 red"> {{taxNo}} </span>
          人未算税</span>
        <!-- <span v-if="taxFail>0">
          ，可在 算薪结果明细 表格“错误信息”列查看错误信息。请修改人员信息后重新校验，或确认继续对校验成功人员算税。
        </span> -->
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isTaxing">
        <el-button size="small" @click="showAllTax = false">关闭</el-button>
      </span>
    </el-dialog>

    <div class="dialogBox">
      <el-dialog title="数据错误提醒" :visible.sync="showError" :show-close="false" width="600px">

        <div v-if="FormatCheckList.length > 0">
          <div class="errNumTips">本批发薪有<span class="errNum">{{ FormatCheckList.length }}</span>条数据格式有错误，请修改后再提交</div>
          <div class="abnItem" v-for="(item, index) in FormatCheckList" :key="index">
            {{ index + 1 }}、第 {{ item.rowNum }} 行，{{ item.Val }}
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="showError = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          AttrMonth: '',
          IncomeTaxMonth: '',
          ProjectName: '',
          IncomeTaxType: '',
          pageNum: 1,
          pageSize: 10,
        },
        Project: '',
        activeName: '0',
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [],
        showImport: false,
        isBtnLoading: false,
        taxSignData: [],
        headPath: this.$store.state.EMP.tablePath,
        baseInfo: {},
        formData: {
          Url: '',
          MonthBatch: '', //本月批次号
          AttrMonth: '', //归属月
          IncomeTaxMonth: '', //个税申报月
          ProjectId: '',
          ProjectName: '',
          IncomeTaxType: '', //个税申报类型
        },
        fileListPSR: [],
        batchData: [],
        showBatch: false,
        isMonthBatchMax: '',
        roleName: localStorage.roleName,
        multipleSelection: [],
        rules: {
          ProjectId: {
            required: true,
            message: '请选择发薪项目',
            trigger: 'change'
          },
          IncomeTaxMonth: {
            required: true,
            message: '请选择个税申报月',
            trigger: 'change'
          },
          IncomeTaxType: {
            required: true,
            message: '请选择个税申报类型',
            trigger: 'change'
          },
          AttrMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          Url: {
            required: true,
            message: '请上传薪资表',
            trigger: 'change'
          },
        },
        showSigning: false, //线下登记
        CompanyName: [], //选择的主体
        legList: [], //法务主体列表
        checked: false,
        LegalSubjectCheckList: [],
        showLegError: false,
        CardIdCheckList: [],
        FormatCheckList: [],
        permissionLists: [],
        showError: false,
        legList2: [], //财务 取到的主体列表
        applyMonth: moment().subtract(1, 'months').format('YYYY-MM'),
        showAllSign: false, //第三步默认全员登记弹窗
        isSigning: false, //登记中
        showAllTax: false, //第三步默认全员计算个税弹窗
        isTaxing: false, //计算个税中
        checkFail: 0, //校验失败数量
        checkSuccess: 0, //校验成功数量
        taxSuccess: 0, //个税计算成功数量
        taxFail: 0, //个税计算失败数量
        taxNo: 0, //未算税个数
        taxLoading: false,
        intervalNum: 0,
        interval: null,
        Id: '',
        showAbnormal: false,
        ret1List: [], //商保信息对比不一致列表
        ret2List: [], //无签约
        isFin: false, //是否是财务
        isExpLoading: false,
        IssuedThisMonthList: [], //相同金额列表
        BankAccountCheckList: [], //银行卡校验异常列表
        IncomeTaxMonth: moment().format('YYYY-MM'), //登记线下个税申报 税款所属期
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < new Date(moment().format('YYYY-MM')) || new Date(moment().add(1, 'months').format('YYYY-MM')) < time.getTime();
          },
        }
      }
    },
    created() {
      this.IsFinancial();
      this.getButtonPower();
      this.getImportOfflinePayrollList();
      this.getProList();
      let now = new Date();
      this.formData.AttrMonth = moment(now).subtract(2, 'months').format('YYYY-MM');
      this.formData.IncomeTaxMonth = moment(now).format('YYYY-MM');
      // this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/calcSalary',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //判断是否是财务
      IsFinancial() {
        xz.IsFinancial(this.roletype).then(res => {
          if (res.status == 'ok') {
            this.isFin = res.data;
          } else {
            this.isFin = false;
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //公司会计取全部法务主体
      getInternalCompNameList() {
        xz.getInternalCompNameList(this.IncomeTaxMonth, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList2 = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.searchHandle();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.searchHandle();
      },
      searchHandle() {
        if (this.activeName == '0') {
          this.getImportOfflinePayrollList();
        } else {
          this.getOfflineInTaxDeclList()
        }
      },
      handleUploadPSR(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.Url = res;
            this.fileListPSR.push({
              name: file.name,
              url: res,
            });
          } else {
            this.formData.DetailsUrl = ''
          }
        });
      },
      handleRemove1() {
        this.formData.PayScaleRUL = '';
        this.fileListPSR = [];
      },
      handleExceed1() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      changePro(val) {
        this.formData.ProjectId = val.Projectid;
        this.formData.ProjectName = val.StrprojectName;
        console.log(this.formData.ProjectId)
        if (this.formData.ProjectId && this.formData.IncomeTaxType && this.formData.IncomeTaxMonth) {
          this.getProjectMonthBatch();
        }
      },
      changeIncomeTaxMonth() {
        this.formData.MonthBatch = '';
        if (this.formData.ProjectId && this.formData.IncomeTaxType && this.formData.IncomeTaxMonth) {
          this.getProjectMonthBatch();
        }
        this.$forceUpdate();
      },
      //选择个税申报类型
      changeIncomeTaxType() {
        this.formData.MonthBatch = '';
        if (this.formData.ProjectId && this.formData.IncomeTaxType && this.formData.IncomeTaxMonth) {
          this.getProjectMonthBatch();
        }
      },
      //获取批次列表
      getProjectMonthBatch() {
        let data = {
          projectid: this.formData.ProjectId,
          IncomeTaxType: this.formData.IncomeTaxType,
          IncomeTaxMonth: this.formData.IncomeTaxMonth,
        }
        xz.getProjectMonthBatch(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.ChannelNameList.length > 0) {
              this.batchData = res.data.ChannelNameList;
              this.showBatch = true;
            } else {
              this.formData.MonthBatch = '0';
            }
          } else {
            this.$message.error('批次获取失败')
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //
      getBatch() {
        if (this.isMonthBatchMax == '0') {
          this.formData.MonthBatch = '0';
        } else if (this.isMonthBatchMax == '1') {
          if (this.multipleSelection.length != 1) {
            this.$message.warning('请选择一条记录覆盖')
          } else {
            this.formData.MonthBatch = this.multipleSelection[0].Cacucode;
            this.showBatch = false;
          }
        }
      },
      //导入薪资表
      importForm() {
        this.formData = {
          Url: '',
          MonthBatch: '', //本月批次号
          AttrMonth: this.formData.AttrMonth, //归属月
          IncomeTaxMonth: this.formData.IncomeTaxMonth, //个税申报月
          ProjectId: '',
          ProjectName: '',
          IncomeTaxType: '', //个税申报类型
        }
        this.Project = '';
        this.fileListPSR = [];
        this.showImport = true;
      },
      downTemp() {
        let path = this.headPath + "excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20240605161736653.xlsx";
        const aTag = document.createElement('a');
        aTag.href = path;
        aTag.download = "导入期初数据模版.xlsx";
        aTag.click();
      },
      beforeImport() {
        this.$refs["formImport"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            // this.formData.MonthBatch
            this.formData['ckeck'] = '1';
            xz.importOfflinePayrollData(this.formData, this.roletype).then(res => {
              if (res.status == 'ok') {
                if (res.data.LegalSubjectCheckList != undefined && res.data.LegalSubjectCheckList.length > 0) {
                  this.LegalSubjectCheckList = res.data.LegalSubjectCheckList;
                  this.showLegError = true;
                  this.isBtnLoading = false;
                } else {
                  if (res.data.FormatCheckList != undefined && res.data.FormatCheckList.length > 0) {
                    this.FormatCheckList = res.data.FormatCheckList;
                    this.showError = true;
                    this.isBtnLoading = false;
                  } else {

                    if (res.data.CardIdCheckList != undefined && res.data.CardIdCheckList.length > 0) {
                      this.CardIdCheckList = res.data.CardIdCheckList;
                    }
                    if (res.data.ckecklist != undefined) {
                      if (res.data.ckecklist != null && res.data.ckecklist != {}) {
                        if (res.data.ckecklist.ret1List != undefined) {
                          this.ret1List = res.data.ckecklist.ret1List
                        }
                        if (res.data.ckecklist.ret2List != undefined) {
                          this.ret2List = res.data.ckecklist.ret2List
                        }
                      }
                    }

                    if (res.data.IssuedThisMonthList != undefined) {
                      this.IssuedThisMonthList = res.data.IssuedThisMonthList;
                    }
                    if (res.data.BankAccountCheckList != undefined) {
                      this.BankAccountCheckList = res.data.BankAccountCheckList;
                    }

                    if (this.IssuedThisMonthList.length == 0 && this.ret1List.length == 0 && this.ret1List.length == 0 && this.FormatCheckList.length == 0 && this.CardIdCheckList.length == 0 && this.BankAccountCheckList == 0) {
                      this.confirmSubmit();
                    } else {
                      this.showAbnormal = true;
                      this.isBtnLoading = false;
                    }
                  }
                }
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
                this.showImport = false;
              }
            })
          }
        })
      },
      continueSubmit() {
        this.showAbnormal = false;
        this.confirmSubmit()
      },
      confirmSubmit() {
        this.showError = false;
        this.formData['ckeck'] = '2';
        this.isBtnLoading = true;
        xz.importOfflinePayrollData(this.formData, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getImportOfflinePayrollList();
            this.$message.success('保存成功！');
            this.isBtnLoading = false;
            this.showImport = false;
            this.Id = res.data;
            this.showAllSign = true;
            this.isSigning = true;
            clearInterval(this.interval);
            setTimeout(() => {
              this.getAllStatus('');
            }, 3000);
            this.intervalNum = 0;
            this.interval = setInterval(this.Refresh2, 10000)
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
            this.showImport = false;
          }
        })
      },
      //继续算税
      continueGetTax() {
        this.taxLoading = true;
        let data0 = {
          projectName: this.formData.ProjectName,
          incomeTaxMonth: this.formData.IncomeTaxMonth
        }
        xz.CheckTaxState(data0).then(res => {
          if (res.status == 'ok') {
            if (res.taxState) {
              this.taxLoading = false;
              this.$message.warning('本项目有正在算税中批次，请等算税批次算税完成后再算税')
            } else {
              this.taxLoading = false;
              this.showAllSign = false;
              this.isTaxing = true;
              this.showAllTax = true;
              this.listQuery.ids = '';
              let data2 = {
                userid: Cookies.get("userid-b"),
                entname: this.baseInfo.Subject,
                objectid: this.baseInfo.ProjectId,
                datestr: this.baseInfo.IncomeTaxMonth,
                cacucode: this.baseInfo.Cacucode,
                id: this.Id
              }
              this.hasGetTax = true;
              xz.senduserlisttax(data2).then(res => {})
              clearInterval(this.interval);
              this.getAllStatus('');
              setTimeout(() => {
                this.getAllStatus('');
              }, 3000);
              this.intervalNum = 0;
              this.interval = setInterval(this.Refresh2, 10000);
            }
          }
        })
      },
      //获取所有状态值
      getAllStatus() {
        let data = {
          pageNum: 1,
          pageSize: 10,
          id: this.Id,
          ids: '',
          CardId: '',
          PersonnelCheck: '',
          EmployeeName: '',
          BankAccount: '',
          checkState: '', //校验状态
          taxState: '', //算税状态
        }
        xz.getApplicationPayrollDetail(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.baseInfo = res.data.data;
            if (this.showAllSign && res.data.checkState == '校验完成' && res.data.checkState != '终止校验') {
              this.checkSuccess = res.data.checkSuccess;
              this.checkFail = res.data.checkFail;
              this.isSigning = false;
              clearInterval(this.interval);
              this.getImportOfflinePayrollList();
            } else if (this.showAllTax && res.data.taxState == '算税完成') {
              this.taxSuccess = res.data.taxSuccess;
              this.taxFail = res.data.taxFail;
              this.taxNo = res.data.taxNo;
              this.isTaxing = false;
              clearInterval(this.interval);
            }
          }
        })
      },
      //刷新状态
      Refresh2() {
        this.intervalNum++;
        this.getAllStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 180) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllSign = false;
          this.showAllTax = false;
          this.$message.warning('查询超时！')
        }
      },
      getTax(row) {
        let data = {
          pageNum: 1,
          pageSize: 10,
          id: row.Id,
          ids: '',
          CardId: '',
          PersonnelCheck: '',
          EmployeeName: '',
          BankAccount: '',
          checkState: '', //校验状态
          taxState: '', //算税状态
        }
        this.Id = row.Id;
        xz.getApplicationPayrollDetail(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.baseInfo = res.data.data;
            this.formData.ProjectName = row.ProjectName;
            this.formData.IncomeTaxMonth = row.IncomeTaxMonth;
            this.continueGetTax();
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //取导入线下发薪数据列表
      getImportOfflinePayrollList() {
        this.loading = true;
        xz.getImportOfflinePayrollList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.RetList;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      exportHandel(row, type, name) {
        this.loading = true;
        let data = {
          Ids: row.Id,
          Type: 2, //1列表 2明细
          state: type
        }
        xz.payrollApplicationExport(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = row.ProjectName + row.IncomeTaxMonth + name + '.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      },
      exportHandel2(row, type, name) {
        this.loading = true;
        let data = {
          Ids: row.Id,
          Type: 2, //1列表 2明细
          taxState: type
        }
        xz.payrollApplicationExport(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = row.ProjectName + row.IncomeTaxMonth + name + '.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      },
      toDetail(row) {
        this.$router.push({
          path: '/salaryDtl',
          query: {
            Id: row.Id
          }
        })
      },
      //删除线下导入数据
      del(row) {
        xz.cancellApplication(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getImportOfflinePayrollList();
            this.$message.success('作废成功！')
          } else {
            this.getImportOfflinePayrollList();
            this.$message.error(res.msg);
          }
        })
      },
      changeTab() {
        if (this.activeName == '0') {
          this.listQuery = {
            AttrMonth: '',
            IncomeTaxMonth: '',
            ProjectName: '',
            IncomeTaxType: '',
            pageNum: 1,
            pageSize: 10,
          }
          this.getImportOfflinePayrollList();
        } else {
          this.listQuery = {
            CompanyName: '',
            IncomeTaxMonth: '',
            pageNum: 1,
            pageSize: 10,
          }
          this.getOfflineInTaxDeclList();
          if (this.legList.length == 0) {
            this.getlegalsubjectlist();
            this.getInternalCompNameList();
          }
        }
      },
      //线下登记
      signing() {
        this.CompanyName = [];
        this.showSigning = true;
      },
      confirmSigning() {
        if (this.CompanyName.length > 0 || this.checked) {
          let data = {
            CompanyName: this.checked ? 'ALL' : this.CompanyName.toString(),
            IncomeTaxMonth: this.IncomeTaxMonth,
            IsDeleted: 0
          };
          xz.addOfflineInTaxDecl(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功')
              this.getOfflineInTaxDeclList();
              this.showSigning = false;
            } else {
              this.showSigning = false;
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.warning('请选择法务主体')
        }
      },
      //获取登记列表
      getOfflineInTaxDeclList() {
        this.loading = true;
        xz.getOfflineInTaxDeclList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.taxSignData = res.data.OfflineInTaxDeclList;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.signData = [];
            this.loading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //登记作废
      delSign(row) {
        let data = {
          CompanyName: row.CompanyName,
          IsDeleted: 1
        }
        xz.addOfflineInTaxDecl(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('作废成功')
            this.getOfflineInTaxDeclList();
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      changeCheck() {
        this.CompanyName = [];
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.taxState == '已算税') {
          return 'warning-row';
        } else {
          return '';
        }
      },
      //导出明细
      exportDtl() {
        this.isExpLoading = true;
        let data = {
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          IncomeTaxMonth: this.listQuery.IncomeTaxMonth,
          ProjectName: this.listQuery.ProjectName
        }
        xz.ExpOfflinePayrollList(data).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = '线下发薪明细.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExpLoading = false;
          } else {
            this.$message.error(res.msg);
            this.isExpLoading = false;
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .blueName {
    text-decoration: underline;
    margin: 0 5px;
    cursor: pointer;
  }

  .red {
    color: red;
  }

  .success {
    color: #19BD92;
  }

  .Checking {
    display: flex;
    justify-content: center;
  }

  .CheckingTips {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }

  .errNum {
    color: #F56C6C;
    margin: 0 7px;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .salaryPayingCompany_radio .el-radio {
    display: block;
    margin: 10px 0;
  }

  .page_offlineSalary .dialogBox .el-dialog__body {
    padding-top: 0px;
  }

  .page_offlineSalary .el-table .warning-row {
    background: #E6FCC5;
  }
</style>